import { Client, fetchExchange } from '@urql/core';
import { retryExchange } from '@urql/exchange-retry';

import { auth } from './exchanges/auth.exchange';
import { cache } from './exchanges/cache.exchange';
import { error } from './exchanges/error.exchange';
import { ws } from './exchanges/ws.exchange';

export const urqlClient = new Client({
  // `||`, not `??`: the Docker build bakes VITE_GRAPHQL_URL="" (empty means
  // "use the nginx proxy at /graphql"), and an empty url would make urql POST
  // to the current page URL.
  url: import.meta.env.VITE_GRAPHQL_URL || '/graphql',
  preferGetMethod: false,
  exchanges: [
    cache,
    auth,
    error,
    retryExchange({
      initialDelayMs: 300,
      maxDelayMs: 3000,
      randomDelay: true,
      maxNumberAttempts: 3,
      retryIf: (error, operation) => operation.kind !== 'mutation' && !!error.networkError,
    }),
    ws,
    fetchExchange,
  ],
  fetchOptions: () => ({
    credentials: 'include' as const,
  }),
});
